import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 8px;
  width: 90vw;
  height: 80vh;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
`;

export const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.5rem;
  color: #333;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f0f0f0;
    color: #333;
  }
`;

export const ModalBody = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

export const ExerciseList = styled.div`
  flex: 2;
  padding: 20px;
  overflow-y: auto;
  border-right: 1px solid #e0e0e0;
`;

export const SearchContainer = styled.div`
  margin-bottom: 20px;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #2196f3;
    box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
  }
`;

export const ExerciseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
`;

export const ExerciseCard = styled.div<{isSelected?: boolean}>`
  border: 2px solid ${(props) => (props.isSelected ? '#2196f3' : '#e0e0e0')};
  border-radius: 8px;
  padding: 15px;
  cursor: pointer;
  transition: all 0.2s;
  background: ${(props) => (props.isSelected ? '#f3f9ff' : 'white')};
  position: relative;

  &:hover {
    border-color: #2196f3;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const ExerciseImage = styled.div`
  width: 100%;
  height: 120px;
  background: #f5f5f5;
  border-radius: 6px;
  margin-bottom: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ExerciseName = styled.h4`
  margin: 0;
  font-size: 1rem;
  color: #333;
  text-align: center;
`;

export const CheckMark = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  background: #4caf50;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
`;

export const PreviewPanel = styled.div`
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  background: #f9f9f9;
`;

export const PreviewContainer = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
`;

export const PreviewImage = styled.div`
  width: 100%;
  height: 200px;
  background: #f5f5f5;
  border-radius: 6px;
  margin-bottom: 15px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const PreviewTitle = styled.h3`
  margin: 0 0 10px 0;
  font-size: 1.25rem;
  color: #333;
`;

export const PreviewDescription = styled.p`
  color: #666;
  line-height: 1.5;
  margin-bottom: 20px;
`;

export const FormSection = styled.div`
  margin-bottom: 20px;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
`;

export const FormField = styled.div`
  flex: 1;
`;

export const FormLabel = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #333;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #2196f3;
  }
`;

export const FormTextarea = styled.textarea`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.9rem;
  outline: none;
  resize: vertical;
  min-height: 80px;
  transition: border-color 0.2s;

  &:focus {
    border-color: #2196f3;
  }
`;

export const ModalFooter = styled.div`
  padding: 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

export const Button = styled.button<{variant?: 'primary' | 'secondary'}>`
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;

  ${(props) =>
    props.variant === 'primary'
      ? `
    background-color: #2196f3;
    color: white;
    
    &:hover:not(:disabled) {
      background-color: #1976d2;
    }
    
    &:disabled {
      background-color: #ccc;
      cursor: not-allowed;
    }
  `
      : `
    background-color: #f5f5f5;
    color: #333;
    
    &:hover {
      background-color: #e0e0e0;
    }
  `}
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: #666;
`;

export const LoadMoreButton = styled.button`
  width: 100%;
  padding: 12px;
  margin-top: 20px;
  border: 2px dashed #ddd;
  background: none;
  border-radius: 6px;
  color: #666;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    border-color: #2196f3;
    color: #2196f3;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
`;

export const NoExerciseSelected = styled.div`
  text-align: center;
  color: #999;
  padding: 40px;
  font-style: italic;
`;

// Tab styles
export const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
`;

export const TabButton = styled.button<{isActive?: boolean}>`
  flex: 1;
  padding: 15px 20px;
  border: none;
  background: ${(props) => (props.isActive ? 'white' : 'transparent')};
  color: ${(props) => (props.isActive ? '#2196f3' : '#666')};
  font-weight: ${(props) => (props.isActive ? 'bold' : 'normal')};
  cursor: pointer;
  transition: all 0.2s;
  border-bottom: 2px solid
    ${(props) => (props.isActive ? '#2196f3' : 'transparent')};

  &:hover {
    background: white;
    color: #2196f3;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

// Create exercise form styles
export const CreateExerciseForm = styled.div`
  padding: 20px;
  max-height: calc(80vh - 200px);
  overflow-y: auto;
`;

export const VideoUploadContainer = styled.div`
  margin-bottom: 20px;
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  background: #fafafa;

  &.uploading {
    border-color: #2196f3;
    background: #f3f9ff;
  }

  &.has-video {
    border-color: #4caf50;
    background: #f8fff8;
  }
`;

export const VideoPreview = styled.div`
  margin-top: 15px;

  video {
    width: 100%;
    max-width: 300px;
    height: auto;
    border-radius: 6px;
  }
`;

export const FormFields = styled.div`
  display: grid;
  gap: 20px;
`;

export const CreateExerciseActions = styled.div`
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
`;

export const UploadProgress = styled.div`
  width: 100%;
  background: #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 10px;

  .progress-bar {
    height: 8px;
    background: linear-gradient(90deg, #2196f3, #1976d2);
    transition: width 0.3s ease;
  }
`;

export const UploadStatus = styled.div`
  margin-top: 10px;
  font-size: 0.9rem;
  color: #666;

  &.success {
    color: #4caf50;
  }

  &.error {
    color: #f44336;
  }
`;
